/* eslint indent: 0 */

const getUuidFrom = (uuidOrHasUuidProp)=>
  uuidOrHasUuidProp.uuid ? uuidOrHasUuidProp.uuid : uuidOrHasUuidProp;

const getIdFrom = (idOrHasIdProp)=> 
  idOrHasIdProp && idOrHasIdProp.id ? idOrHasIdProp.id : idOrHasIdProp;

  
export default {
  getUuidFrom,
  getIdFrom
};

export {
  getUuidFrom,
  getIdFrom
};
